import { User } from '../model/user';

/**
 * Safely reads the cached user from storage.
 *
 * Returns the parsed {@link User} when present, or an empty `User` when no user
 * is stored or the stored value is malformed — instead of throwing. This avoids
 * the `JSON.parse('')` -> `SyntaxError: Unexpected end of JSON input` crash that
 * occurred when components were constructed without a cached user (e.g. an
 * unauthenticated session). Mirrors the localStorage -> sessionStorage fallback
 * used for the auth token.
 */
export function getStoredUser(): User {
  const raw = localStorage.getItem('user') ?? sessionStorage.getItem('user');
  if (!raw) {
    return {} as User;
  }
  try {
    return JSON.parse(raw) as User;
  } catch {
    return {} as User;
  }
}
